import { Dial } from '@sorrem-client/ui/components';
import classnames from 'classnames';
import { useBranchMastery } from '../../hooks';
import styles from './MasteryDials.module.scss';
import { toTourTargetProps } from '@sorrem-client/ui/shared/tour-targets';

interface MasteryDialsProps {
    className?: string;
}

/** One dial per progression branch: Veil Attunement, Crafting, and Martial Discipline. */
export function MasteryDials({ className }: MasteryDialsProps): JSX.Element {
    const { branches } = useBranchMastery();

    return (
        <div className={classnames(styles.masteryDials, className)} {...toTourTargetProps('mastery-dials')}>
            {branches.map((branch) => (
                <Dial
                    key={branch.id}
                    label={branch.label}
                    value={branch.masteryPercent}
                    milestones={branch.milestones}
                    detail={branch.detail}
                />
            ))}
        </div>
    );
}
